export default "__VITE_ASSET__DCuvIWsf__"